import { EPermissions } from '@enums/permissions.enum';

/**
 * A user needs at least one of these to see anything on the Settings page at all -
 * `userGroupDeleteMemberOwn` for the User Management tab, `campaignCreate` for the Global
 * Templates tab. Kept as one shared source so the settings route guard (app.routes.ts) and the
 * sidebar's "Settings" nav item + its separator (sidebar.component.html) can't drift out of sync
 * with each other - each previously hardcoded its own copy of this same pair.
 *
 * Deliberately NOT reused for settings.component.html/.ts's own per-tab gates (each tab there is
 * gated on exactly one of these permissions individually, e.g. `campaignCreate` alone for Global
 * Templates) or for SettingsSidebarComponent.items (same per-tab shape) - those are legitimately
 * single-permission checks, not this combined "can see the page at all" OR.
 */
export const SETTINGS_ACCESS_PERMISSIONS: EPermissions[] = [
  EPermissions.userGroupDeleteMemberOwn,
  EPermissions.campaignCreate,
];

/** Same permissions as `SETTINGS_ACCESS_PERMISSIONS`, reshaped for `*hasPermissionGroups`'
 * OR-of-AND-groups input (each permission as its own single-permission group) rather than
 * `*hasPermission`'s/the route guard's flat ANY-of-these array. */
export const SETTINGS_ACCESS_PERMISSION_GROUPS: EPermissions[][] = SETTINGS_ACCESS_PERMISSIONS.map((permission) => [
  permission,
]);
